import {
  ROBOT_UPLOAD_HRDF_SUCCESS,
} from './uploadHRDFRequest';

export const uploadHRDFSuccess = (id) => ({
  type: ROBOT_UPLOAD_HRDF_SUCCESS,
  payload: {
    id,
  }
});